/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_SCENARIO_VARIABLES_SUCCESS = 'GET_SCENARIO_VARIABLES_SUCCESS'
export const GET_SCENARIO_VARIABLES_FAILURE = 'GET_SCENARIO_VARIABLES_FAILURE'

// -- CREATE
export const CREATE_SCENARIO_VARIABLE_SUCCESS = 'CREATE_SCENARIO_VARIABLE_SUCCESS'
export const CREATE_SCENARIO_VARIABLE_FAILURE = 'CREATE_SCENARIO_VARIABLE_FAILURE'

// -- UPDATE
export const UPDATE_SCENARIO_VARIABLE_SUCCESS = 'UPDATE_SCENARIO_VARIABLE_SUCCESS'
export const UPDATE_SCENARIO_VARIABLE_FAILURE = 'UPDATE_SCENARIO_VARIABLE_FAILURE'

// -- DELETE
export const DELETE_SCENARIO_VARIABLE_SUCCESS = 'DELETE_SCENARIO_VARIABLE_SUCCESS'
export const DELETE_SCENARIO_VARIABLE_FAILURE = 'DELETE_SCENARIO_VARIABLE_FAILURE'

// -- SEARCH
export const SEARCH_SCENARIO_VARIABLES = 'SEARCH_SCENARIO_VARIABLES'

// ____________________________________________________________

/**
 * SEARCH for a scenario's variable's attribute based on its name.
 *
 * @param {string} terms Text to be searched within the scenario variable.
 * @returns {Promise<array<object>>}
 */
export const searchScenarioVariables = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_SCENARIO_VARIABLES,
    data: terms
  })
}

/**
 * GET the list of all the variables that belong to a specific scenario.
 *
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<array<object>>}
 */
export const getScenarioVariables = (pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_VARIABLE_LIST, { pid, sid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.getScenarioVariables()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_SCENARIO_VARIABLES_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_SCENARIO_VARIABLES_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a scenario variable attribute.
 *
 * @param {object} newVariable New variable to be created.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const createScenarioVariable = (newVariable, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_VARIABLE_CREATE, { pid, sid })
  const api = new Api(path)
  const result = await api.create(newVariable)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.createScenarioVariable()', { path, newVariable, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_SCENARIO_VARIABLE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_SCENARIO_VARIABLE_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific scenario variable attribute.
 *
 * @param {object} newVariable New scenario's variable's attribute object that will replace the previous one.
 * @param {uuid} vid Scenario variable ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const updateScenarioVariable = (newVariable, vid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_VARIABLE_UPDATE, { pid, sid, vid })
  const api = new Api(path)
  const result = await api.update(newVariable)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.updateScenarioVariable()', { path, newVariable, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_SCENARIO_VARIABLE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_SCENARIO_VARIABLE_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific scenario's variable's attribute.
 *
 * @param {uuid} vid Scenario variable ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const deleteScenarioVariable = (vid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_VARIABLE_DELETE, { pid, sid, vid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.deleteScenarioVariable()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_SCENARIO_VARIABLE_SUCCESS,
      data: vid
    })
  }
  return dispatch({
    type: DELETE_SCENARIO_VARIABLE_FAILURE,
    data: result.data
  })
}
